import viewMixin from '@/mixins/viewMixins'

/**
 * @file リスト画面用Mixin
 * @namespace mixins
 */
/**
 * @module listMixins
 */
/**
 * @vue-data {String} [searchText=''] - 絞り込みテキスト
 * @vue-data {Array} [rows=[]] - 一覧用データリスト
 * @vue-data {Array} [headers=[]] - ヘッダリスト
 * @vue-data {Object} [refs={}] - this.$refs
 * @vue-computed {Number} rowCount - レコード件数
 * @vue-computed {Number} filteredRowCount - 絞り込み後レコード件数
 */
export default {
  mixins: [viewMixin],
  data: () => ({
    searchText: '',
    rows: [],
    headers: [],
    refs: {},
    tableHeight: 0
  }),
  mounted: function () {
    // リサイズ用グローバルイベントを定義
    const self = this
    this.$router.app.$on('element-resize', function (param) {
      // console.log('listMixins resize event', param, this)
      self.onResize(param)
    })
  },
  computed: {
    rowCount () {
      return this.rows.length
    },
    filteredRows () {
      return this.rows
    },
    filteredRowCount () {
      const items = this.headers.map(h => h.value)
      const text = this.searchText
      const length = this.filteredRows.filter(r => {
        for (let i = 0; i < items.length; i++) {
          const hit = this.filtering(r[items[i]], text, r)
          if (hit) { return true }
        }
        return false
      }).length
      return length
    }
  },
  methods: {
    filtering (value, search, item) {
      return this.Filters.filter(value, search, item)
    },
    onResize (param) {
      // マージン分
      const margin = 195
      const otherHeight = param.headerHeight + param.messageHeight + this.calcHeightWithoutTables()
      const tableheight = this.$vuetify.breakpoint.height - otherHeight - margin
      this.$set(this, 'tableHeight', tableheight)
    },
    /**
     * mixin先の【_calcHeight-】で始まるrefsの高さの合計を求める
     * @returns {Number} DataTable以外の高さ(clientHeight)の合計
     */
    calcHeightWithoutTables () {
      const elems = Object.keys(this.$refs).filter(r => {
        // console.log('calcHeightWithoutTables', r)
        return r.startsWith('_calcHeight-')
      })
      let height = 0
      // console.log('calcHeightWithoutTables', this)
      const refs = this.$refs
      elems.forEach(function (r) {
        // console.log('calcHeightWithoutTables', this, refs[r])
        if (refs[r] === undefined) { return }
        height += refs[r].clientHeight
      })
      return height
    }
  }
}
